export const formatNumber = (value: number): number => {
  return Number(Number(value).toFixed(2));
};
